import { useState, useEffect } from "react";
import BackMethods from "../../back_component/BackMethods";
import { useNavigate, useLocation } from "react-router-dom";

export default function SalesTypesManagementPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const { backEnd_request } = BackMethods();

    const successMessage = location.state?.successMessage;
    const [deleteSuccessMessage, setDeleteSuccessMessage] = useState("");

    const [types, setTypes] = useState([]);
    const [filteredTypes, setFilteredTypes] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    // جلب البيانات
    const fetchTypes = async () => {
        try {
            const res = await backEnd_request.get("/SalesTypes");
            setTypes(res.data);
            setFilteredTypes(res.data);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        fetchTypes();
    }, []);

    // بحث
    const handleSearch = (term) => {
        setSearchTerm(term);
        const f = types.filter((t) =>
            t.name.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredTypes(f);
    };

    // حذف
    const handleDelete = async (id) => {
        if (!window.confirm("هل أنت متأكد من الحذف؟")) return;

        try {
            await backEnd_request.delete(`/SalesTypes/${id}`);
            fetchTypes();
            setDeleteSuccessMessage("تم حذف نوع البيع بنجاح ✅");
            setTimeout(() => setDeleteSuccessMessage(""), 3000);
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <div className="container py-5">

            <div className="d-flex justify-content-between align-items-center mb-4">
                <h3 className="fw-bold text-primary">إدارة أنواع البيع</h3>
                <button
                    className="btn btn-success"
                    onClick={() => navigate("/admin/sales-types-management/create")}
                >
                    إضافة نوع بيع
                </button>
            </div>

            {successMessage && <div className="alert alert-success text-center">{successMessage}</div>}
            {deleteSuccessMessage && <div className="alert alert-success text-center">{deleteSuccessMessage}</div>}

            {/* البحث */}
            <div className="card shadow-sm mb-4 p-3">
                <input
                    type="text"
                    className="form-control"
                    placeholder="ابحث حسب اسم النوع..."
                    value={searchTerm}
                    onChange={(e) => handleSearch(e.target.value)}
                />
            </div>

            {/* الجدول */}
            <div className="table-responsive shadow-sm">
                <table className="table table-hover text-center">
                    <thead className="table-primary">
                        <tr>
                            <th>الاسم</th>
                            <th>إجراءات</th>
                        </tr>
                    </thead>

                    <tbody>
                        {filteredTypes.length > 0 ? (
                            filteredTypes.map((t) => (
                                <tr key={t.salesTypeId}>
                                    <td>{t.name}</td>
                                    <td>
                                        <button
                                            className="btn btn-sm btn-outline-primary me-2"
                                            onClick={() =>
                                                navigate(`/admin/sales-types-management/edit/${t.salesTypeId}`)
                                            }
                                        >
                                            تعديل
                                        </button>

                                        <button
                                            className="btn btn-sm btn-outline-danger"
                                            onClick={() => handleDelete(t.salesTypeId)}
                                        >
                                            حذف
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="2" className="text-muted py-4">
                                    لا توجد بيانات
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
